import { useMemo } from 'react';
// Import Store
import { useAppSelector } from 'store';
import { selectPartnerDateFormats } from 'store/slices/partnerSettings';
// Import Helpers
import { replaceDayTokens } from 'services/Helpers';
// Import Enums
import { PartnerDateFormat } from 'enums';
// Import Constants
import { DateFormat, DateTimeFormat, DateTimeWithoutSecondsFormat } from 'constants/common';

export const usePartnerDateFormats = (): Record<PartnerDateFormat, string> => {
    const { Date, DateTime, DateTimeWithoutSeconds } = useAppSelector(selectPartnerDateFormats) ?? {};

    const memoizedValue = useMemo(() => {
        return {
            [PartnerDateFormat.Date]: replaceDayTokens(Date) || DateFormat,
            [PartnerDateFormat.DateTime]: replaceDayTokens(DateTime) || DateTimeFormat,
            [PartnerDateFormat.DateTimeWithoutSeconds]:
                replaceDayTokens(DateTimeWithoutSeconds) || DateTimeWithoutSecondsFormat,
        };
    }, [Date, DateTime, DateTimeWithoutSeconds]);

    return memoizedValue;
};
